var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MinuteTypeList',_vm._b({on:{"select":_vm.select,"copy":_vm.copy}},'MinuteTypeList',{ questions: _vm.questions, actions: _vm.actions },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }